export default __webpack_public_path__ + "media/application/images/nyu-6dac212bb94bf23cd400df6fdd43aca4.svg";